import { msg } from '@lingui/core/macro'
import { defineEnum } from '@pkg/shared/utils/enum-builder'

export const PatientOrderFormTypeEnum = defineEnum({
  AntibiosisOrder: msg`Antibiose`,
  EnteralLiquidFoodOrder: msg`Enteral-Trinknahrung`,
  EnteralTubeFeedingOrder: msg`Enteral-Sondenkost`,
  HeimparenteralBagsOrder: msg`{variant, select, short {Beutel} other {Heimparenteral Beutel & zugehörige Artikel}}`,
  HeimparenteralMedicalDevicesOrder: msg`{variant, select, short {Medizintechnik} other {Heimparenteral - Medizintechnik und zugehörige Artikel}}`,
  PainTherapyOrder: msg`Schmerztherapie`,
  PortIrrigationOrder: msg`Portspülung`,
  PowerPiccSupplyOrder: msg`Power-PICC Versorgung`,
})

export type PatientOrderFormTypeType = typeof PatientOrderFormTypeEnum.$.Type

export const PatientSignedFormTypeEnum = defineEnum({
  ProgressReport: msg`Verlaufsdokumentation`,
  PatientInformation: msg`Patienteninformation`,
  PatientConsentAndConfidentiality: msg`Einwilligungs- und Schweigepflichtserklärung`,
  PatientSupply: msg`Versorgungsauftrag`,
})

export type PatientSignedFormTypeType = typeof PatientSignedFormTypeEnum.$.Type

export const PatientFormTypeEnum = defineEnum({
  ...PatientOrderFormTypeEnum.$.messages,
  ...PatientSignedFormTypeEnum.$.messages,
  MasterDataSheet: msg`Stammblatt`,
  BiaMeasurement: msg`BIA-Messung`,
})

export type PatientFormTypeType = typeof PatientFormTypeEnum.$.Type

// Legacy compatibility - keep the old object structure for code that accesses values directly
export const PatientFormType = PatientFormTypeEnum.$.enum
export const PatientOrderFormType = PatientOrderFormTypeEnum.$.enum
export const PatientSignedFormType = PatientSignedFormTypeEnum.$.enum
